module.exports = __webpack_public_path__ + "static/img/3areaA_18.615a17f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/クリスマス/3areaA_18.png
// module id = 838
// module chunks = 1